// SZadmin status → badge config (fg/bg/label). Source: design_handoff_szadmin/TOKENS.md
// Each badge renders as a pill with a leading dot in the fg color (see .sz-badge in szadmin.css).

export const JOB_STATUS = {
  PENDING_APPROVAL:   { label: "Pending",      fg: "#B45309", bg: "#FEF3C7" },
  SEEKING_APPLICANTS: { label: "Seeking",      fg: "#2563EB", bg: "#DBEAFE" },
  OFFER_SENT:         { label: "Offer Sent",   fg: "#572B7C", bg: "#EDE4F4" },
  HIRED:              { label: "Hired",        fg: "#0E7490", bg: "#CFFAFE" },
  PARTIALLY_HIRED:    { label: "Partial",      fg: "#4338CA", bg: "#E0E7FF" },
  PENDING_COMPLETION: { label: "Pending Comp", fg: "#C2410C", bg: "#FFEDD5" },
  RELEASE_PAYMENT:    { label: "Release Pay",  fg: "#0F766E", bg: "#CCFBF1" },
  PAID_COMPLETED:     { label: "Completed",    fg: "#15803D", bg: "#DCFCE7" },
  CANCELLED:          { label: "Cancelled",    fg: "#B91C1C", bg: "#FEE2E2" },
};

export const USER_STATUS = {
  new:       { label: "New",       fg: "#2563EB", bg: "#DBEAFE" },
  pending:   { label: "Pending",   fg: "#B45309", bg: "#FEF3C7" },
  approved:  { label: "Approved",  fg: "#15803D", bg: "#DCFCE7" },
  rejected:  { label: "Rejected",  fg: "#B91C1C", bg: "#FEE2E2" },
  suspended: { label: "Suspended", fg: "#475569", bg: "#E2E8F0" },
  bounced:   { label: "Bounced",   fg: "#EA580C", bg: "#FFEDD5" },
};

export const LEAD_STATUS = {
  pending:   { label: "Pending",   fg: "#B45309", bg: "#FEF3C7" },
  approved:  { label: "Approved",  fg: "#15803D", bg: "#DCFCE7" },
  archived:  { label: "Archived",  fg: "#475569", bg: "#E2E8F0" },
  cancelled: { label: "Cancelled", fg: "#B91C1C", bg: "#FEE2E2" },
};

export const MONEY = { fg: "#15803D", bg: "#DCFCE7" };

const FALLBACK = { label: "—", fg: "#475569", bg: "#E2E8F0" };

export function jobStatus(s) {
  return JOB_STATUS[s] || { ...FALLBACK, label: (s || "").replace(/_/g, " ") || "—" };
}
export function userStatus(s) {
  return USER_STATUS[(s || "").toLowerCase()] || { ...FALLBACK, label: s || "—" };
}
export function leadStatus(s) {
  return LEAD_STATUS[(s || "").toLowerCase()] || { ...FALLBACK, label: s || "—" };
}

// Inline style object for a .sz-badge given an {fg,bg} config.
export function badgeStyle(cfg) {
  return { color: cfg.fg, background: cfg.bg };
}
